import { num, type ComponentForm } from '../component-types.js';

/**
 * `lod` (Unity's LOD Group). Level 0 is the entity's own mesh; each entry of
 * `levels` takes over at a camera `distance` (or below a `screenSize`) and
 * draws a mesh source, `auto:<ratio>` (simplified copy), `impostor` (baked
 * billboard of the base mesh, settings in `impostor`) or `none`. See
 * engine/docs/systems/lod-and-impostors.md.
 */
const form: ComponentForm = {
  key: 'lod',
  label: 'LOD Group',
  icon: 'layers',
  order: 115,
  defaults: {
    levels: [
      { distance: 30, source: 'auto:0.5' },
      { distance: 80, source: 'impostor', impostor: { layout: 'ring', frames: 8, resolution: 128 } },
      { distance: 250, source: 'none' },
    ],
    fade: 0.1,
    fadeMode: 'crossFade',
    fadeDuration: 0.5,
  },
  fields: [
    {
      key: 'levels',
      label: 'Levels',
      type: { kind: 'json' },
      hint: '[{ distance | screenSize, source, impostor? }] from detailed to coarse. source: a mesh source, "auto:0.5", "impostor" or "none". impostor: { layout: ring | hemisphere | octahedral, frames, resolution, alphaCutoff }. Bake impostors with the "Bake impostors" button below or `prism model impostor <project>` (native runtimes bake missing ones in the background).',
    },
    {
      key: 'fade',
      label: 'Switch band',
      type: num(0.01, { min: 0, max: 0.9 }),
      hint: 'Hysteresis: a threshold must be passed by this fraction before the level changes (no flicker at the boundary).',
    },
    {
      key: 'fadeMode',
      label: 'Fade mode',
      type: { kind: 'enum', options: ['crossFade', 'none'] },
      hint: 'crossFade: the old and new level dither into each other. none: instant swap.',
      read: (v) => v.fadeMode ?? 'crossFade',
    },
    {
      key: 'fadeDuration',
      label: 'Fade duration',
      type: num(0.05, { min: 0, max: 10 }),
      hint: 'Seconds a cross-fade takes.',
      showIf: (v) => v.fadeMode !== 'none',
      read: (v) => v.fadeDuration ?? 0.5,
    },
  ],
};
export default form;
